"use strict";

var __createBinding = this && this.__createBinding || (Object.create ? function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
    desc = {
      enumerable: true,
      get: function () {
        return m[k];
      }
    };
  }
  Object.defineProperty(o, k2, desc);
} : function (o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});
var __setModuleDefault = this && this.__setModuleDefault || (Object.create ? function (o, v) {
  Object.defineProperty(o, "default", {
    enumerable: true,
    value: v
  });
} : function (o, v) {
  o["default"] = v;
});
var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
  __setModuleDefault(result, mod);
  return result;
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useFootnotes = void 0;
const react_1 = __importStar(require("react"));
const lodash_1 = __importDefault(require("lodash"));
const prop_types_1 = require("prop-types");
const react_style_proptype_1 = __importDefault(require("react-style-proptype"));
const types_1 = require("./types");
const styles_module_css_1 = __importDefault(require("./styles.module.css"));
const utilities_1 = require("../../utilities");
const useFootnotes = _ref => {
  let {
    data,
    chartFootnotes = [],
    showMetricFootnotes = true
  } = _ref;
  const customFootnotes = (0, lodash_1.default)(chartFootnotes).flatMap(_ref2 => {
    let {
      title = '',
      data: footnotesData = ''
    } = _ref2;
    return {
      data: footnotesData,
      name: title
    };
  }).value();
  if (!showMetricFootnotes) {
    if (!lodash_1.default.isNil(customFootnotes) && customFootnotes.length > 0) {
      return {
        footnotes: (0, lodash_1.default)(customFootnotes).uniqBy(footnotes => footnotes.data).groupBy(footnotes => footnotes.name).map((footnotes, name) => ({
          footnotes,
          name
        })).value()
      };
    }
    return [];
  }
  const footnotes = (0, lodash_1.default)(data).flatMap(_ref3 => {
    let {
      meta = [],
      name = []
    } = _ref3;
    if (meta) {
      return meta.map(_ref4 => {
        let {
          data: metaData
        } = _ref4;
        return {
          data: metaData,
          name
        };
      });
    }
    return [];
  }).concat(customFootnotes).uniqBy(function () {
    let {
      data: metaData
    } = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    return metaData;
  }).groupBy(_ref5 => {
    let {
      name
    } = _ref5;
    return name;
  }).map((value, name) => ({
    footnotes: value,
    name
  })).value();
  return {
    footnotes
  };
};
exports.useFootnotes = useFootnotes;
exports.useFootnotes.propTypes = {
  data: (0, prop_types_1.arrayOf)(types_1.footnoteDataType).isRequired,
  chartFootnotes: (0, prop_types_1.arrayOf)((0, prop_types_1.shape)({
    data: prop_types_1.string,
    title: prop_types_1.string
  })),
  showMetricFootnotes: prop_types_1.bool
};
const Footnotes = _ref6 => {
  let {
    footnotes,
    style = {
      fontSize: 14,
      lineHeight: 1.5,
      marginBottom: '0.5em'
    }
  } = _ref6;
  const [collapsed, setCollapsed] = (0, react_1.useState)(true);
  function getFootnoteInfo(_ref7) {
    let {
      footnotes: info,
      name
    } = _ref7;
    const getSubNote = _ref8 => {
      let {
        data
      } = _ref8;
      return react_1.default.createElement("div", {
        className: styles_module_css_1.default['long-data'],
        key: data
      }, data);
    };
    const subNoteList = info.map(subNote => getSubNote(subNote));
    if (subNoteList.length === 0) return null;
    return react_1.default.createElement("div", {
      className: styles_module_css_1.default['footnote-long'],
      key: name
    }, react_1.default.createElement("div", {
      className: styles_module_css_1.default['long-title']
    }, name), subNoteList);
  }
  function trimPreview(previewString) {
    if (previewString.length > 50) {
      return `${previewString.substr(0, 50)}...`;
    }
    return previewString;
  }
  if (lodash_1.default.isNil(footnotes) || footnotes.length === 0) {
    return null;
  }
  const footnoteLinks = footnotes.map(footnote => getFootnoteInfo(footnote));
  const preview = footnotes[0].footnotes[0].data;
  return react_1.default.createElement("div", {
    className: `${styles_module_css_1.default['text-expander']} footnotes`,
    style: style
  }, react_1.default.createElement("div", {
    className: styles_module_css_1.default['text-ex-title']
  }, "Footnotes:"), collapsed ? react_1.default.createElement("div", {
    className: styles_module_css_1.default['text-ex-summary']
  }, react_1.default.createElement("span", {
    className: styles_module_css_1.default['footnote-preview'],
    key: preview
  }, trimPreview(preview)), react_1.default.createElement("div", {
    className: styles_module_css_1.default['text-ex-more'],
    role: "button",
    tabIndex: 0,
    onKeyDown: event => {
      (0, utilities_1.handleKeyboardCommand)(event, () => {
        setCollapsed(false);
      });
    },
    onClick: () => setCollapsed(false)
  }, react_1.default.createElement("div", {
    className: styles_module_css_1.default['more-text']
  }, "see more"), react_1.default.createElement("div", {
    className: styles_module_css_1.default.arrow
  }))) : react_1.default.createElement("div", {
    className: styles_module_css_1.default['text-ex-expander']
  }, react_1.default.createElement("div", {
    className: styles_module_css_1.default['text-ex-content']
  }, footnoteLinks), react_1.default.createElement("div", {
    className: styles_module_css_1.default['text-ex-less'],
    role: "button",
    tabIndex: 0,
    onKeyDown: event => {
      (0, utilities_1.handleKeyboardCommand)(event, () => {
        setCollapsed(true);
      });
    },
    onClick: () => setCollapsed(true)
  }, react_1.default.createElement("div", {
    className: styles_module_css_1.default['less-text']
  }, "see less"), react_1.default.createElement("div", {
    className: styles_module_css_1.default.arrow
  }))));
};
Footnotes.propTypes = {
  /**
   * Array of footnotes, each with a categorizing name and footnote data.
   */
  footnotes: (0, prop_types_1.arrayOf)(types_1.customFootnoteType).isRequired,
  /**
   * Style for the container.
   */
  style: react_style_proptype_1.default
};
exports.default = Footnotes;